/**
 * Which surfaces the Forward+ renderer draws into a shadow map: those that draw depth, from the
 * opaque list or from the alpha pass through a depth prepass.
 */
/** `FLAG_PASS_SHADOW` (`render_forward_clustered.cpp:4078-4088`). */
export function drawsInShadowPass({ alphaPass, depthInAlphaPass }) {
    return !alphaPass || depthInAlphaPass;
}
//# sourceMappingURL=shadowPass.js.map